import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CeoApi from "../../apis/ceo.api";

const initialState = {
  isLoading: true,
  homeData: null,
};

export const url = ``;

export const fetchHome = createAsyncThunk(
  "home/fetchHome",
  async (request, { dispatch }) => {
    const response = await CeoApi.getHome(request);
    return response.data.data;
  }
);

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setHomeData: (state, action) => {
      state.homeData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHome.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchHome.fulfilled, (state, action) => {
        state.isLoading = false;
        state.homeData = action.payload;
      })
      .addCase(fetchHome.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const selectIsLoading = (state) => state.home.isLoading;
export const selectError = (state) => state.home.error;
export const selectPayload = (state) => state.home.payload;
export const { setHomeData } = homeSlice.actions;

export default homeSlice.reducer;
